// src/components/AdSenseAd.jsx
import React, { useEffect } from 'react';

const isLocalhost = () => {
  try {
    return (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1'
    );
  } catch {
    return false;
  }
};

const AdSenseAd = ({ adSlot = 'REPLACE_WITH_AD_SLOT', style = {}, className = '' }) => {
  const showPlaceholder = isLocalhost() || process.env.NODE_ENV !== 'production';

  useEffect(() => {
    if (!showPlaceholder) {
      console.log('Trying to load AdSense ad:', adSlot); 
      console.log('Window.adsbygoogle available:', !!window.adsbygoogle); // Add this
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.warn('adsbygoogle push failed', e);
      }
    }
  }, [showPlaceholder]);

  if (showPlaceholder) {

    return (
      <div
        className={className}
        style={{
          display: 'block',
          width: '100%',
          padding: '20px 0',
          textAlign: 'center',
          background: '#f1f1f1',
          color: '#333',
          borderRadius: 8,
          ...style,
        }}
      >
        [Ad placeholder — AdSense will display on deployed, verified site]
      </div>
    );
  }

  // Real ad container for production
  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block', ...style }}
      data-ad-client="ca-pub-1292784405025549"
      data-ad-slot={adSlot}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
};

export default AdSenseAd;
